import { DAY_IN_MS } from '../../../utils/time';

export const durationAwayBeforeQuestNotifTrigger = 3 * DAY_IN_MS;
